// extracted by mini-css-extract-plugin
export default {"container":"footer_container__padpO","contact":"footer_contact__k-eKb"};